export enum OptionScale {
  Fit = 'OptionScale_Fit',
  CenterCrop = 'OptionScale_CenterCrop'
}
